import './Typeface.css';
import { useParams, Link } from 'react-router-dom';
import typefaces from '../../assets/constants/typefaces.js'
import Footer from '../Footer.js';
import React from "react";

function Typeface(props) {
    let params = useParams();

    let typefaceSelected = typefaces.find ((typeface) =>
    typeface.pageName === params.typeFaceName)

    if (typeof typefaceSelected === "undefined") {
        return (
            <div className="notValid">
                <Link className="link" to="/" >
                    <p className="backButton"> back to home </p>
                </Link>
                <p className="notValidText"> {params.typefaceName} is not a valid typeface</p>
            </div>
        )
    }
    else 
    return (
        <div className="story">
            <Link className="link" to="/" >
                <p className="backButton"> back to home </p>
            </Link>
            <Link className="link" to="/type" >
                <p className="backButton secondBackButton"> back to all typefaces </p>
            </Link>
            <h1 className="storyHeaderText"> {typefaceSelected.name}</h1>
            {/* <h1 className="typefaceHeaderSubtext"> {typefaceSelected.description} </h1> */}
            <p className="typefaceBodyText"> free for personal use - <a className="typefaceHref" href={typefaceSelected.href}> download on github </a></p>
            <img className="typefaceImage" src={typefaceSelected.hrefPoster} alt={typefaceSelected.altPoster} />
        <Footer/>
        </div>

    )

}

export default Typeface;